type Props = {
    text: string;
}

const SectionTitle = (props: Props) => (
    <h3 className="section-title">{props.text}</h3>
);
  
export default SectionTitle;